import React, { useState, useEffect } from "react";
import axios from "axios";
import { API } from "../utils/apk";


const Offer = () => {
  const [offers, setOffers] = useState([]);
  const [functionOffer, setFunctionOffer] = useState("");
  const [editingId, setEditingId] = useState(null);
const [storeStatus, setStoreStatus] = useState("close");
  // Fetch all offers on component mount
  useEffect(() => {
    fetchOffers();
  }, []);

  const fetchOffers = async () => {
    try {
      const res = await axios.get(`${API}/get/all/offer`);
      setOffers(res.data);
    } catch (err) {
      console.error("Error fetching offers:", err);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingId) {
        await axios.put(`${API}/update/offer/${editingId}`, { functionOffer });
      } else {
        await axios.post(`${API}/create/function/offer`, { functionOffer });
      }
      setFunctionOffer("");
      setEditingId(null);
      fetchOffers();
    } catch (err) {
      console.error("Error submitting offer:", err);
    }
  };

  const handleEdit = (offer) => {
    setFunctionOffer(offer.functionOffer);
    setEditingId(offer._id);
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${API}/delete/offer/${id}`);
      fetchOffers();
    } catch (err) {
      console.error("Error deleting offer:", err);
    }
  };
  useEffect(() => {
  fetchStoreStatus();
}, []);

const fetchStoreStatus = async () => {
  try {
    const response = await axios.get(
      `${API}/get/store/status`
    );

    if (response.data.success) {
      setStoreStatus(response.data.storeStatus);
    }
  } catch (error) {
    console.error("Error fetching store status:", error);
  }
};

const toggleStoreStatus = async () => {
  try {
    const response = await axios.put(
      `${API}/update/store/status`
    );

    if (response.data.success) {
      setStoreStatus(response.data.storeStatus);
    }
  } catch (error) {
    console.error("Error updating store status:", error);
  }
};
  return (
    <div className="max-w-xl mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Manage Offers</h2>
<div className="mb-6">
  <button
    onClick={toggleStoreStatus}
    className={`px-6 py-3 rounded-lg text-white font-bold transition ${
      storeStatus === "open"
        ? "bg-green-600 hover:bg-green-700"
        : "bg-red-600 hover:bg-red-700"
    }`}
  >
    Restaurant is {storeStatus === "open" ? "OPEN" : "CLOSED"}
  </button>
</div>
      <form onSubmit={handleSubmit} className="mb-6 space-y-4">
        <input
          type="text"
          value={functionOffer}
          onChange={(e) => setFunctionOffer(e.target.value)}
          placeholder="Enter offer"
          className="w-full px-4 py-2 border border-gray-300 rounded-lg"
          required
        />
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
        >
          {editingId ? "Update Offer" : "Add Offer"}
        </button>
      </form>

      <ul className="space-y-4">
        {offers.map((offer) => (
          <li
            key={offer._id}
            className="bg-white shadow p-4 rounded-lg flex justify-between items-center"
          >
            <span>{offer.functionOffer}</span>
            <div className="flex space-x-2">
              <button
                onClick={() => handleEdit(offer)}
                className="text-yellow-500 hover:text-yellow-600"
              >
                Edit
              </button>
              <button
                onClick={() => handleDelete(offer._id)}
                className="text-red-500 hover:text-red-600"
              >
                Delete
              </button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Offer;
